module.exports = __webpack_public_path__ + "static/media/Percival Graves 2.3f7f9ad4.jpg";